import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";
import { apiFetch } from "@core/index";
import { IUpdatePublishersPayload } from "../utils/types";
import { apiEndpoint } from "../utils/constants";

export const useUpdatePublisher = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (config: { payload: IUpdatePublishersPayload }) => {
      const { id, payloadData } = config.payload;
      const response = await apiFetch<{
        statusCode: number;
        message: string;
        data?: unknown;
      }>(`${apiEndpoint}/${id}`, {
        method: "PATCH",
        body: payloadData,
      });
      return response;
    },
    onSuccess: () => {
      enqueueSnackbar("Publisher updated successfully.", {
        variant: "success",
        autoHideDuration: 2000,
      });
      queryClient.invalidateQueries({ queryKey: ["publishers"] });
    },
    onError: (error: Error) => {
      enqueueSnackbar("Failed to update publisher. Error: " + (error ?? ""), {
        variant: "error",
        autoHideDuration: 5000,
      });
    },
  });
};
